import moment from 'moment-timezone'
import { Schema, SchemaSettings } from '@orbit/data'
import { findRemoteIdFromNewRecord, KC } from '@/http/utils'
import { CardioExercise, StrengtheningExercise } from '@/jsonapi/PatientExercise'

enum ModelTypes {
  ExerciseProgramSession = 'exercise-session',
}

enum ModelTypeNames {
  ExerciseProgramSession = 'exerciseSession',
}

interface PatientExerciseIds {
  patientId: string
  exerciseId: string
}

export interface ExerciseProgramSessionAttributes {
  programId: string
  date: string
  startTimestamp: number
  endTimestamp: number
  participants: string[]
  patientExerciseIds: PatientExerciseIds[]
  strengtheningExercises: StrengtheningExercise[]
  cardioExercises: CardioExercise[]
}

export interface ExerciseProgramSessionSchema {
  id: string
  attributes: ExerciseProgramSessionAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.ExerciseProgramSession]: {
      attributes: {
        resourceId: { type: 'string' },
        programId: { type: 'string' },
        createdByUsername: { type: 'string' },
        createdTimestamp: { type: 'number' },
        lastUpdatedByUsername: { type: 'string' },
        lastUpdatedTimestamp: { type: 'number' },
        date: { type: 'string' },
        startTimestamp: { type: 'number' },
        endTimestamp: { type: 'number' },
        participants: { type: 'array' },
        patientExerciseIds: { type: 'array' },
        strengtheningExercises: { type: 'array' },
        cardioExercises: { type: 'array' },
      },
    },
  },
}

export async function getExerciseProgramSessionQuery() {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for exercise program sessions')
      return q.findRecords(ModelTypes.ExerciseProgramSession)
    })
    .catch(e => {
      console.log('fetch failed for exercise program sessions')
      console.log(e)
    })
}

export type PostExerciseProgramSessionPayload = {
  programId: string
  date: string
  startTimestamp: number
  endTimestamp: number
  participants: string[]
  strengtheningExercises: StrengtheningExercise[]
  cardioExercises: CardioExercise[]
}

export async function postExerciseProgramSessionQuery(payload: PostExerciseProgramSessionPayload) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResourceForNewRecord(schema)
  const result = await remote.push(q => {
    console.log('before calling push record for exercise program exercise session')
    return q.addRecord({
      id: '',
      type: ModelTypeNames.ExerciseProgramSession,
      attributes: {
        programId: payload.programId,
        date: payload.date,
        startTimestamp: payload.startTimestamp,
        endTimestamp: payload.endTimestamp,
        participants: payload.participants,
        strengtheningExercises: payload.strengtheningExercises,
        cardioExercises: payload.cardioExercises,
      },
    })
  })
  return findRemoteIdFromNewRecord(result)
}

export async function patchExerciseProgramSessionQuery(payload) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote.push(q => {
    console.log('Before calling update record for exercise program exercise session')
    return q.updateRecord({
      id: payload.id,
      type: ModelTypeNames.ExerciseProgramSession,
      attributes: payload.attributes,
    })
  })
}

export async function deleteExerciseProgramSessionQuery(exerciseSessionId: string) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote.push(q => {
    console.log('Before calling remove record for exercise program session')
    return q.removeRecord({
      id: exerciseSessionId,
      type: ModelTypeNames.ExerciseProgramSession,
    })
  })
}
